export default function(callback, ms = 200) {
  let lastTimeout;

  return (...args) => {
    clearTimeout(lastTimeout);
    lastTimeout = setTimeout(callback.bind(this, ...args), ms);
  };
}
